import React, { useState, useEffect, useRef } from 'react';
import './searchableDropdown.css';

const SearchableDropdown = ({ 
  value, 
  onChange, 
  onSelect, 
  placeholder, 
  options, 
  label,
  containerStyle,
  inputStyle,
  dropdownStyle,
  optionStyle,
  disabled,
  onClear,
  loading,
  trailingIcon,
  onTrailingIconClick,
  style,
  disableLocalFilter = false,
  selectedItem = null,
  closeIcon = null,
  onFocus = null,
  onScrollEnd = null
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  // Handle clicks outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showDropdown]);

  const handleInputChange = (e) => {
    if (!disabled) {
      const newValue = e.target.value;
      onChange(newValue);
      if (!showDropdown) {
        setShowDropdown(true);
      }
    }
  };

  const handleInputFocus = () => {
    if (!disabled) {
      setShowDropdown(true);
      if (onFocus) {
        onFocus();
      }
    }
  };

  const handleSelect = (option) => {
    onSelect(option);
    setShowDropdown(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
    setShowDropdown(false);
    if (onClear) {
      onClear();
    }
    // Refocus input after clearing
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  return (
    <div 
      ref={containerRef}
      className="searchable-dropdown-container" 
      style={containerStyle}
    >
      {label && (
        <label className="searchable-dropdown-label">
          {label}
        </label>
      )}
      <div className="searchable-dropdown-input-wrapper">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          placeholder={placeholder}
          className="searchable-dropdown-input filter-date-input"
          disabled={disabled}
          style={{ ...inputStyle, ...style, paddingRight: (selectedItem && closeIcon) || trailingIcon || (value && !disabled) ? 35 : undefined }}
          autoComplete="off"
        />
        {selectedItem && closeIcon ? (
          <img
            src={closeIcon}
            alt="Clear"
            onClick={handleClear}
            className="searchable-dropdown-trailing-icon"
            style={{ cursor: 'pointer' }}
          />
        ) : trailingIcon ? (
          <img
            src={trailingIcon}
            alt="Trailing Icon"
            onClick={onTrailingIconClick}
            className="searchable-dropdown-trailing-icon"
            style={{ cursor: 'pointer' }}
          />
        ) : value && !disabled ? (
          <button
            type="button"
            onClick={handleClear}
            className="searchable-dropdown-clear-button"
          >
            ✕
          </button>
        ) : null}
      </div>
      {showDropdown && !disabled && (
        <div 
          className="searchable-dropdown-list" 
          style={dropdownStyle}
          onScroll={onScrollEnd ? (e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollHeight - scrollTop - clientHeight < 50) {
              onScrollEnd();
            }
          } : undefined}
        >
          {loading ? (
            <div className="searchable-dropdown-loading">
              <div className="searchable-dropdown-spinner"></div>
              <span>Loading...</span>
            </div>
          ) : options && options.length > 0 ? (
            options.map((option, index) => (
              <div
                key={option.id || index}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelect(option);
                }}
                className="searchable-dropdown-option"
                style={optionStyle}
              >
                {option.name}
              </div>
            ))
          ) : value && !loading ? (
            <div className="searchable-dropdown-no-results">
              No results found
            </div>
          ) : !loading ? (
            <div className="searchable-dropdown-no-results">
              No results found
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;